<template>
  <Popover v-model:open="localIsOpen">
    <PopoverTrigger as-child>
      <Button 
        variant="text" 
        class="select-none rounded-full w-12 h-12 relative hover:bg-muted/40"
        :class="{ 'text-primary': localIsOpen }"
      >
        <Icon name="heroicons:inbox" class="w-4 h-4" />
        
        <!-- Unread count badge -->
        <div 
          v-if="unreadCount > 0"
          v-motion
          :initial="{ opacity: 0, scale: 0.5 }"
          :enter="{ opacity: 1, scale: 1 }"
          :leave="{ opacity: 0, scale: 0.5 }"
          class="absolute top-2 right-2 bg-blue-500 text-white text-[10px] font-medium rounded-full min-w-[16px] h-[16px] flex items-center justify-center"
        >
          {{ unreadCount > 99 ? '99+' : unreadCount }}
        </div>
      </Button>
    </PopoverTrigger>

    <PopoverContent 
      align="end" 
      side="bottom"
      class="p-0 w-fit rounded-3xl shadow-xxl !border-none backdrop-blur-md !bg-white/80 dark:!bg-muted"
      :side-offset="-48"
      :align-offset="-45"
    >
    <!-- <Button @click="localIsOpen = false" variant="text" class="absolute top-0 right-0 rounded-full w-12 h-12"><Icon name="lucide:x" class="w-4 h-4" /></Button> -->
      <UserInbox @close="localIsOpen = false" />
    </PopoverContent>
  </Popover>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import UserInbox from './UserInbox.vue'
import { useMessages } from '@/composables/useMessages'

const { unreadCount } = useMessages()

// Local state for popover control (similar to CreditsPopover pattern)
const localIsOpen = ref(false)
</script> 